var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 3.81824C6.79628 3.81824 5.81812 4.79641 5.81812 6.00005C5.81812 7.20369 6.79628 8.18186 7.99993 8.18186C9.20357 8.18186 10.1817 7.20369 10.1817 6.00005C10.1817 4.79641 9.20354 3.81824 7.99993 3.81824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 0.545532C4.36364 0.545532 1.25819 2.80733 0 6.00008C1.25819 9.1928 4.36364 11.4546 8.00002 11.4546C11.64 11.4546 14.7418 9.1928 16 6.00008C14.7418 2.80733 11.64 0.545532 8.00002 0.545532ZM8.00002 9.63642C5.99274 9.63642 4.36364 8.00732 4.36364 6.00005C4.36364 3.99277 5.99274 2.3637 8.00002 2.3637C10.0073 2.3637 11.6364 3.99281 11.6364 6.00008C11.6364 8.00735 10.0073 9.63642 8.00002 9.63642Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowText);
export default __webpack_public_path__ + "static/media/show_text.bc30c0558080e04c553e372405607583.svg";
export { ForwardRef as ReactComponent };